export default "__VITE_ASSET__44e4f9ae__"